import React from 'react'
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import AppButton from "../../ui/AppButton";
import AppInputText from "../../ui/AppInputText";
import AppInputTel from "../../ui/AppInputTel";
import AppInputCel from "../../ui/AppInputCel";
import PersonIcon from '@material-ui/icons/Person';
import Colors from "../../config/colors";
import Avatar from "@material-ui/core/Avatar";
import AppInputNumber from "../../ui/AppInputNumber";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import AlertPrivacyPolicy from "./AlertPrivacyPolicy";
import {Checkbox, FormControlLabel} from "@material-ui/core";
import AlertDataTreatment from "./AlertDataTreatment";

class UpdateProfileForm extends React.Component {

    state = {
        openModal: false,
        openModalTD: false,
        aceptaPP: true,
        aceptaTD: true,
    };

    handleOpenModal = () => {
        this.setState({openModal: true})
    }

    handleCloseModal = () => {
        this.setState({openModal: false})
    }

    handleOpenModalTD = () => {
        this.setState({openModalTD: true})
    }

    handleCloseModalTD = () => {
        this.setState({openModalTD: false})
    }

    render() {

        const {
            documentoTipoID,
            terceroDocumento,
            terceroNombre1,
            terceroNombre2,
            terceroApellido1,
            terceroApellido2,
            terceroMail,
            terceroTel,
            terceroCel,
            terceroDireccion,

        } = this.props.form;

        const {onChange, onSubmit, loadData} = this.props;

        return (
            <div>
                <form onSubmit={onSubmit}>
                    <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="center">

                        <Card className='container-login'>

                            <Avatar style={{background: Colors.accent, marginLeft: '45%'}}>
                                <PersonIcon/>
                            </Avatar>

                            <CardHeader title="Actualizar datos"/>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl required variant="outlined" style={{width: '100%'}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Tipo Documento</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id={documentoTipoID.key}
                                            name={documentoTipoID.key}
                                            value={documentoTipoID.value}
                                            onChange={onChange}
                                            label="Tipo Documento"
                                            disabled={true}
                                            required={documentoTipoID.required}
                                            variant='outlined'
                                        >

                                            {loadData.documentTypes.map((val, index) => {
                                                return (
                                                    <MenuItem key={index}
                                                              value={val.documentoTipoID}>{val.documentoTipoDescripcion}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputNumber
                                        id={terceroDocumento.key}
                                        disabled={true}
                                        name={terceroDocumento.key}
                                        value={terceroDocumento.value}
                                        label='Número de documento'
                                        onChange={onChange}
                                        required={terceroDocumento.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroNombre1.key}
                                        name={terceroNombre1.key}
                                        value={terceroNombre1.value}
                                        label='Primer Nombre'
                                        onChange={onChange}
                                        required={terceroNombre1.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroNombre2.key}
                                        name={terceroNombre2.key}
                                        value={terceroNombre2.value}
                                        label='Segundo Nombre'
                                        onChange={onChange}
                                        required={terceroNombre2.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroApellido1.key}
                                        name={terceroApellido1.key}
                                        value={terceroApellido1.value}
                                        label='Primer Apellido'
                                        onChange={onChange}
                                        required={terceroApellido1.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroApellido2.key}
                                        name={terceroApellido2.key}
                                        value={terceroApellido2.value}
                                        label='Segundo Apellido'
                                        onChange={onChange}
                                        required={terceroApellido2.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroMail.key}
                                        name={terceroMail.key}
                                        value={terceroMail.value}
                                        label='Email'
                                        onChange={onChange}
                                        required={terceroMail.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputTel
                                        id={terceroTel.key}
                                        name={terceroTel.key}
                                        value={terceroTel.value}
                                        label='Teléfono'
                                        onChange={onChange}
                                        required={terceroTel.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputCel
                                        id={terceroCel.key}
                                        name={terceroCel.key}
                                        value={terceroCel.value}
                                        label='Celular'
                                        onChange={onChange}
                                        required={terceroCel.required}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <AppInputText
                                        id={terceroDireccion.key}
                                        name={terceroDireccion.key}
                                        value={terceroDireccion.value}
                                        label='Dirección'
                                        onChange={onChange}
                                        required={terceroDireccion.required}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <p style={{fontStyle: 'italic'}}>Los campos marcados con (*) son obligatorios.</p>
                                </Grid>

                                <Grid item xs={12} style={{textAlign: 'left'}}>
                                    <FormControlLabel
                                        control={<Checkbox readOnly={true} checked={this.state.aceptaPP}/>}
                                        label={
                                            <span style={{fontSize: '.8rem'}}> Acepto la
                                                <span style={{cursor: 'pointer', color: '#1976d2'}}
                                                      onClick={this.handleOpenModal}> Política de Privacidad
                                                </span>
                                            </span>}
                                    />
                                </Grid>

                                <Grid item xs={12} style={{textAlign: 'left'}}>
                                    <FormControlLabel
                                        control={<Checkbox readOnly={true} checked={this.state.aceptaTD}/>}
                                        label={
                                            <span style={{fontSize: '.8rem'}}>
                                                Acepto que mis datos sean tratados conforme a la política de tratamiento de
                                                datos de Electrohuila S.A. - E.S.P. y la ley 1581 de 2.012 la cual incluye
                                                el ofrecimiento de productos y servicios.
                                                <span style={{cursor: 'pointer', color: '#1976d2'}}
                                                      onClick={this.handleOpenModalTD}> Más información
                                                </span>
                                            </span>}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <AppButton
                                        type='submit'
                                        label='Guardar'
                                        size='large'
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </form>

                <AlertPrivacyPolicy
                    executeAPI={true}
                    showAgreeButton={false}
                    disabledClose={false}
                    openModal={this.state.openModal}
                    onCloseModal={this.handleCloseModal}
                />

                <AlertDataTreatment
                    executeAPI={true}
                    showAgreeButton={false}
                    disabledClose={false}
                    openModal={this.state.openModalTD}
                    onCloseModal={this.handleCloseModalTD}
                />

            </div>
        );
    }

}

export default UpdateProfileForm
